import { useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody, Col } from "reactstrap";

export default function BoxCard({ label, count, color = "#1b3765", onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Col lg={1} xs={6} className="p-2" style={{ minWidth: "11rem" }}>
      <Card
        className="text-white text-center shadow rounded"
        style={{
          background: color,
          cursor: "pointer",
          transform: hovered ? "scale(1.05)" : "scale(1)",
          transition: "transform 0.3s ease-in-out",
        }}
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <CardBody>
          <h3 className="fw-bold mb-1">
            <CountUp end={count} duration={1.2} />
          </h3>
          <p className="mb-0 fw-medium">{label}</p>
        </CardBody>
      </Card>
    </Col>
  );
}
